import React from 'react';

import { Page, Header, Container } from '@constellation/core';
import { ContentProvider } from '@interstellar/react-app-content';
import { useLocation } from '@interstellar/react-app-routing';

import LayoutProps from './Applayout.types';
import Footer from '../../components/footer/FooterComponent';
import content from '../../content';
import dataQaIds from '../../dataModel/dataQaIds';
import { StyledBox } from '../../pages/fullSignatoryPage/FullSignatoryPage.styled';
import { LANDING_PAGE_PATH } from '../../utils/constant';
import useAppConfig from '../appConfig/useAppConfig';

function AppLayout({ children }: LayoutProps): React.JSX.Element {
  const brand = useAppConfig().BRAND_NAME;
  const { pathname } = useLocation();
  const bgColor =
    (window as any).appConfig.BRAND_NAME === 'lloyds' ? 'brand1' : 'brand2';
  return (
    <Page>
      <Header data-qa-id={dataQaIds.header.container} />
      <StyledBox
        marginBottom="none"
        marginLeft="none"
        padding="none"
        marginTop="none"
        marginRight="none"
        bgColor={pathname === LANDING_PAGE_PATH ? bgColor : 'none'}
      >
        <Container marginTop="06">{children}</Container>
      </StyledBox>

      <ContentProvider value={content({ brand }).footer}>
        <Footer />
      </ContentProvider>
    </Page>
  );
}

export default AppLayout;
